import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ContentCard from "@/components/feature/ContentCard";
import { useSEO } from "@/hooks/useSEO";
import { getFeaturedCarousel, getHotContents, getLatestContents } from "@/lib/content";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuickLinks from "@/pages/home/components/CategoryQuickLinks";
import HotScroll from "@/pages/home/components/HotScroll";
import TopicSection from "@/pages/home/components/TopicSection";
import IntroSection from "@/pages/home/components/IntroSection";

export default function Home() {
  useSEO({
    title: "羞羞网站 - 综合娱乐内容聚合平台",
    description:
      "羞羞网站提供丰富多样的娱乐内容，包括趣味视频、搞笑段子和轻松访谈，是休闲娱乐用户的优选平台。",
    keywords: "羞羞网站,娱乐内容,搞笑视频,趣味段子,轻松娱乐,休闲平台",
  });

  const carousel = getFeaturedCarousel(5);
  const latest = getLatestContents(6);
  const hot = getHotContents(10);

  return (
    <div className="w-full bg-background-50">
      <Navbar />
      <main>
        <HeroCarousel items={carousel} />
        <CategoryQuickLinks />

        <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-8">
            <div>
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 flex items-center gap-2">
                <i className="ri-time-line text-primary-500" />
                最新上线
              </h2>
              <p className="text-sm text-foreground-600 mt-2">
                刚刚出炉的新鲜快乐，一刷就停不下来。
              </p>
            </div>
            <Link
              to="/search"
              className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap"
            >
              查看全部内容
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {latest.map((item) => (
              <ContentCard key={item.id} item={item} />
            ))}
          </div>
        </section>

        <HotScroll items={hot} />
        <TopicSection />
        <IntroSection />
      </main>
      <Footer />
    </div>
  );
}